import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=b8080202&scoped=true"
import script from "./jobList.vue?vue&type=script&lang=js"
export * from "./jobList.vue?vue&type=script&lang=js"
import style0 from "./jobList.vue?vue&type=style&index=0&id=b8080202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8080202",
  null
  
)

export default component.exports